// extracted by mini-css-extract-plugin
export default {"option":"Option__option--SRwwy"};